import { useState } from "react";
import app from "nystem";
import { Button, TextInput } from "nystem-components";

const ViewButtonLogin = ({ view, model }) => {
  const [saveButton, setSaveButton] = useState(app.t("Log in"));
  const [authenticatorCode, setAuthenticatorCode] = useState("");
  const [needsAuthenticator, setNeedsAuthenticator] = useState(false);
  const [busy, setBusy] = useState(false);
  const password = app.contentType[view.contentType]?.item.find((item) => item.type === "password");

  const handleSubmit = async () => {
    if (busy) return;
    const { errors = [] } = await view.event("validate");

    if (errors.length) {
      view.event("error", "Correct validation errors");
      return;
    }
    setSaveButton("Logging in");
    setBusy(true);
    view.value.contentType = view.contentType;
    const { error } = await app.session.login({ ...view.value, authenticatorCode });

    if (error === "toomany") view.event("error", "Too many attempts, try again later");
    else if (error === "authenticator") {
      setNeedsAuthenticator(true);
      view.event("error", "Enter a new authenticator code or an unused recovery code");
    } else if (error === "secondfactor") view.event("error", "Sign in with a passkey or set up an authenticator app");
    else if (error) view.event("error", "Wrong login or password");
    else if (model.redirectURL) window.history.replaceState({}, "", model.redirectURL);

    setSaveButton("Log in");
    setBusy(false);
  };

  const loginWithPasskey = async () => {
    if (busy) return;
    setBusy(true);
    const response = await app.connection.emit({
      type: "passkeyOptions",
      contentType: view.contentType,
      origin: window.location.origin,
    });
    if (response.error) view.event("error", response.error);
    else {
      const { startAuthentication } = await import("@simplewebauthn/browser");
      const result = await startAuthentication({ optionsJSON: response.options }).then(
        (passkey) => app.session.login({ contentType: view.contentType, passkey }),
        () => ({ error: "Passkey login was cancelled or unavailable" }),
      );
      if (result.error) view.event("error", "Passkey login failed or was cancelled");
      else if (model.redirectURL) window.history.replaceState({}, "", model.redirectURL);
    }
    setBusy(false);
  };

  return (
    <>
      {(password?.authenticator || needsAuthenticator) && (
        <TextInput
          model={{ text: "Authenticator or recovery code (if enabled)", mandatory: false }}
          value={authenticatorCode}
          setValue={setAuthenticatorCode}
        />
      )}
      <Button className={model.className} type={model.btnType} size={model.size} disabled={busy} onClick={handleSubmit}>
        {saveButton}
      </Button>
      {password?.passkey && (
        <Button className="ml-3" size={model.size} disabled={busy} onClick={loginWithPasskey}>
          {app.t("Sign in with passkey")}
        </Button>
      )}
    </>
  );
};
export default ViewButtonLogin;
